import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DepartmentService } from 'src/app/services/department.service';
import { environment } from 'src/environments/environment';
import { CfgCellDirective } from 'src/app/common/table/table-cell.directive';
import { TableColumn } from 'src/app/common/table/table-column.model';
import { tableResource } from 'src/app/common/table/table-resource';
import { CfgTableComponent } from 'src/app/common/table/table.component';
import { Synchronization } from '../synchronization.model';

@Component({
    selector: 'app-synchronization-list',
    templateUrl: './synchronization-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CfgTableComponent, CfgCellDirective, DatePipe]
})
export class SynchronizationListComponent {

    private readonly departmentService = inject(DepartmentService);
    private readonly commonService = inject(CommonService);

    // Tom afdeling er gyldig her — endpointet returnerer så alle synkroniseringer.
    protected readonly synchronizationsResource = tableResource<Synchronization>(() => {
        const department = this.departmentService.selectedDepartment();
        const departmentId =
            department?.id && department.id !== this.commonService.guidEmpty() ? department.id : '';
        return `${environment.adminConfig.apiUri}/synchronization/list/bydepartment/${departmentId}`;
    });

    protected readonly columns: TableColumn<Synchronization>[] = [
        { key: 'name', header: 'Navn', width: '400px' },
        { key: 'customer', header: 'Kunde', width: '300px', value: item => `${item.customerName} [${item.customerId}]` },
        { key: 'company', header: 'Regnskab', value: item => `${item.companyName} [${item.companyId}]` },
        { key: 'activated', header: 'Aktiveret', width: '100px', value: item => (item.activated ? 'Ja' : 'Nej') },
        { key: 'enabled', header: 'Aktiv',  width: '100px', value: item => (item.activated ? (item.enabled ? 'Ja' : 'Nej') : '') },
        { key: 'changed', header: 'Ændret', width: '200px',  type: 'date', interactive: false },
    ];

    protected readonly defaultSort = { key: 'name', direction: 'asc' } as const;
    protected readonly trackById = (item: Synchronization) => item.id;
    protected readonly rowLink = (item: Synchronization) => ['/synchronization', item.id];
}
